var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { action, autorun, flow, when } from 'mobx';
import { Observer } from 'mobx-react-lite';
import React from 'react';
import { useOnMount } from '../../hooks/lifecycle.hooks';
import { useObservableRef } from '../../hooks/useObservableRef.hook';
import joinClassName from '../../utils/className.utils';
import { checkIfShouldInvertStyle } from '../../utils/colors.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import { isString } from '../../utils/typeChecks.utils';
import tick from '../../utils/wait.utils';
import BaseIcon from '../BaseIcon/BaseIcon';
import BaseLabel from '../BaseLabel/BaseLabel';
import './BaseInput.scss';
export var BaseInput = function (props) {
    var p = useProps(props);
    var componentRef = useObservableRef();
    var localRef = useObservableRef();
    var s = useStore(function () { return ({
        get model() {
            return p.form;
        },
        get target() {
            return p.field;
        },
        get type() {
            return p.type || 'text';
        },
        get name() {
            return p.name || "" + p.field;
        },
        touched: false,
        value: '',
        get validationResults() {
            var inputValidators = __spreadArray([], (p.validators || []), true);
            var result = inputValidators.map(function (v) { return v(s.value); });
            return result;
        },
        get isValid() {
            return s.validationResults.every(function (i) { return i === true; });
        },
        get hasError() {
            return p.hasError || !s.isValid;
        },
        get placeholder() {
            if (p.placeholder)
                return p.placeholder;
            switch (s.type) {
                case 'search': return 'Search...';
                case 'date': return 'yyyy-mm-dd';
                case 'time': return '--:--';
                default: return '';
            }
        },
        get formatter() {
            var _a;
            var formatter = (_a = p.formatter) !== null && _a !== void 0 ? _a : (s.type === 'number' ? function (v) { return +v; } : function (v) { return v; });
            return formatter;
        },
        get hasActions() {
            return p.canClear || p.showHideKeyboardIcon;
        },
        filterByPattern: function (v) {
            if (!v)
                return v;
            var pattern = p.pattern;
            if (!pattern)
                return v;
            if (pattern === '[0-9]*')
                pattern = /\d/;
            var result = '';
            if (typeof pattern === 'string') {
                result = (v + '').split('').filter(function (i) { return pattern.includes(i); }).join('');
            }
            else
                result = (v + '').split('').filter(function (i) { return i.match(pattern); }).join('');
            // console.log(result);
            switch (typeof v) {
                // @ts-ignore
                case 'string': return result;
                // @ts-ignore
                case 'number': return +result;
                default: return v;
            }
        },
        handleChange: action(function (e) {
            var newValueRaw = e.currentTarget.nodeName === 'DIV' ? e.currentTarget.innerText : e.currentTarget.value;
            var newValue = s.filterByPattern(newValueRaw);
            if (newValue === s.value)
                return;
            s.value = newValue;
            if (p.applyOnBlur)
                return;
            else
                s.applyValue(newValue);
        }),
        applyValue: action(function (v) {
            var newValue = s.formatter(v);
            var shouldUpdate = p.applyOnlyIfValid ? s.isValid : true;
            // console.log('baseinput applyvalue', p.applyOnlyIfValid, shouldUpdate, s.validationResults);
            if (shouldUpdate) {
                s.model && (s.model[s.target] = newValue);
                p.onChange && p.onChange(s.value);
            }
        }),
        updateValue: action(function (v) { return s.value = v; }),
        get defaultEmptyValue() {
            return p.defaultEmptyValue === void 0 ? null : p.defaultEmptyValue;
        },
        clearValue: action(function () {
            s.applyValue(s.defaultEmptyValue);
            s.focus();
        }),
        isInverted: false,
        hasFocus: false,
        handleFocus: action(function (e) {
            s.hasFocus = true;
            if (p.onFocus)
                p.onFocus(e);
            // yield tick(162);
            // UI.measureTemporaryWindowDimensionOverrides();
        }),
        handleBlur: flow(function (e) {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e && e.preventDefault();
                        if (p.applyOnBlur)
                            s.applyValue(s.value);
                        s.touched = true;
                        if (p.onBlur)
                            p.onBlur(e);
                        return [4 /*yield*/, tick(100)];
                    case 1:
                        _a.sent();
                        s.innerRef.current && s.innerRef.current.blur();
                        s.hasFocus = false;
                        return [2 /*return*/];
                }
            });
        }),
        focus: function () {
            s.innerRef.current && s.innerRef.current.focus();
            s.handleFocus();
        },
        blur: function () {
            s.innerRef.current && s.innerRef.current.blur();
            s.handleBlur();
        },
        handleKeyup: function (e) {
            var _a;
            (_a = p.onKeyUp) === null || _a === void 0 ? void 0 : _a.call(p, e);
            if (e.key === 'Enter' || ((e.which || e.keyCode) === 13)) {
                p.onEnter && p.onEnter(e);
            }
        },
        get className() {
            return joinClassName('BaseInput', p.className, (s.touched && p.colorCodedState) && "state-" + p.colorCodedState, (s.touched && !s.isValid) && 'invalid', p.disabled && 'disabled', s.hasFocus && 'focus', s.hasActions && 'hasActions', s.isInverted && 'inverted', s.hasError && 'error');
        },
        get actionButtons() {
            return [
                p.canClear && React.createElement(BaseIcon, { key: "clearButton", className: "BaseInput__clearButton", name: "close", onClick: s.clearValue }),
                p.showHideKeyboardIcon && React.createElement(BaseIcon, { key: "hideKeyboardIcon", className: "BaseInputHideKeyboardIcon", name: "hide-keyboard", onClick: s.blur }),
            ].filter(function (i) { return i; });
        },
        get enterKeyHint() {
            var enterKeyHint = p.enterKeyHint;
            if (!enterKeyHint) {
                switch (s.type) {
                    case 'search':
                        enterKeyHint = 'search';
                        break;
                    default: break;
                }
            }
            return enterKeyHint;
        },
        get commonAttributes() {
            return {
                'data-cy': p.dataCy,
                value: s.value,
                name: s.name,
                placeholder: p.placeholder,
                onClick: p.onClick,
                onChange: s.handleChange,
                onFocus: s.handleFocus,
                onBlur: s.handleBlur,
                onKeyUp: s.handleKeyup,
                disabled: p.disabled,
                autoComplete: p.autoComplete,
                required: p.required,
                enterKeyHint: s.enterKeyHint,
                autoFocus: p.autoFocus,
                pattern: p.pattern ? p.pattern + '' : undefined,
                autoCorrect: p.autoCorrect,
                autoCapitalize: p.autoCapitalize,
            };
        },
        get innerRef() {
            return p.innerRef || localRef;
        },
        get resize() {
            if (isString(p.resize))
                return p.resize;
            return p.resize ? undefined : 'none';
        }
    }); });
    useOnMount(action(function () {
        s.isInverted = checkIfShouldInvertStyle(componentRef);
        if (p.autoSelect) {
            when(function () { return Boolean(s.innerRef.current); }, function () {
                s.innerRef.current.focus();
                s.innerRef.current.select();
            });
        }
        return autorun(function () { return s.updateValue((s.model && s.model[s.target]) || ''); });
    }));
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: s.className, ref: componentRef, "data-name": p.name || p.field },
            p.label && React.createElement(BaseLabel, { children: p.label, inline: p.inlineLabel, required: p.required, optional: p.optional, endSlot: p.endOfLabel }),
            React.createElement("div", { className: "BaseInputInner" },
                s.type === 'textarea' ? (React.createElement("textarea", __assign({ ref: s.innerRef, className: "BaseInputTextarea", rows: p.rows ? +p.rows : undefined }, s.commonAttributes, { style: { resize: s.resize } }))) : (React.createElement("input", __assign({ ref: s.innerRef, className: "BaseInputInput", type: s.type, min: p.min, max: p.max, step: p.step }, s.commonAttributes, { style: __assign({}, p.inputStyle) }))),
                s.actionButtons.length > 0 && React.createElement("div", { className: "BaseInputActionButtonGroup" }, s.actionButtons)),
            p.infoAfterInputField && React.createElement("div", { className: "BaseInputInfoAfterInputField" }, p.infoAfterInputField))); } });
};
export default BaseInput;
